import React, { Fragment } from "react";
import styled from "styled-components";
import { Grid } from "@material-ui/core";

const SelectedNoItemGrid = styled(Grid)`
  &&&& {
        margin-left: 5px;
        padding: 12px;
        background-color: rgb(242, 242, 242);
        font-family: "Roboto Medium", "Roboto Regular", Roboto;
        font-weight: 500;
        font-style: normal;
        font-size: 17px;
        color: rgb(153, 153, 153);
  }`;

export const NoItems = ({ Message }) => (<Grid container direction="row" justify="flex-start" alignItems="center" spacing={0}>
  <SelectedNoItemGrid container item>{Message}</SelectedNoItemGrid>
                                         </Grid>);
